import { render, staticRenderFns } from "./VueDatatableMenuOptions.vue?vue&type=template&id=4ad94a06"
import script from "./VueDatatableMenuOptions.vue?vue&type=script&lang=js"
export * from "./VueDatatableMenuOptions.vue?vue&type=script&lang=js"
import style0 from "./VueDatatableMenuOptions.vue?vue&type=style&index=0&id=4ad94a06&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports